import repositories from '../api/RepositoryFactory';

export default (function () {
  const userAgreementButton = document.getElementById("userAgreementButton");
  if (!userAgreementButton) {
    return;
  }
  userAgreementButton.addEventListener("click", async (event) => {
    event.preventDefault();
    userAgreementButton.disabled = true;
    userAgreementButton.innerHTML = `<span class="spinner-border spinner-border-sm"></span> 処理中...`;

    try {
      await repositories.userAgreementRepository.storeAgreement();
    } catch (error) {
      userAgreementButton.disabled = false;
      userAgreementButton.innerHTML = "同意して進む";
    }

  });

})();
